import { Component } from '@angular/core';

@Component({
  selector: 'app-browser-info',
  templateUrl: './browser-info.component.html',
  styleUrls: ['./browser-info.component.scss']
})
export class BrowserInfoComponent {

  constructor() { }

}
